import { Component, Injector, Input, Optional } from "@angular/core";
import { UserLoginHistory, UserLoginHistoryService } from "@mango/authentication";
import { ColumnDefinition, createColumnDefinitions, Filter, PagedCollectionComponent, SearchableType, TitleService } from "@mango/core";
import { User } from "./user";


@Component({
    selector: 'user-login-history-collection',
    templateUrl: 'login-history-collection.component.html',
})

export class UserLoginHistoryCollectionComponent extends PagedCollectionComponent<UserLoginHistory> {

    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<UserLoginHistory>([
		{ prop: 'date', searchable: SearchableType.Date },
        { prop: 'ipAddress', searchable: SearchableType.String },
    ]);

    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: UserLoginHistoryService,private titleService: TitleService, @Optional() injector: Injector, @Optional() protected filter: Filter<UserLoginHistory>) {
        super('/api/userLoginHistory', injector, UserLoginHistory);

        if(!this.filter) {
            this.filter = new Filter<UserLoginHistory>();
        }

        this.orderBy = [-1];
        setTimeout(()=>this.titleService.setCollectionTitle("Login Historie"));
        
        this.initInput('user', this.filterBuilder.equal(x => x.user.id));

        this.filter.onGetChipLabel(x => x.date, () => 'Datum');
        this.filter.onGetChipLabel(x => x.ipAddress, () => 'Ip');
        
    }

    @Input() set user(val: User) { 
        this.handleInput('user', val.id);        
    }

    ngOnInit() {
        super.ngOnInit();
     }
}
